<template lang="pug">
yz-filter-menu(:label="$t('panel.visit_type')" :is-active="isActive" :display-value="displayValue" :disable-apply="selectedTypes.length === 0" @clear="onClear" @apply="onApply")
  template(v-slot:header)
    .font-semibold.text-sm.pa-4 {{ $t('filter_by') }} {{ $t('panel.visit_type').toLowerCase() }}
  div
    div(v-for="option in visitTypeOptions" :key="option.value")
      .d-flex.text-sm.px-4.py-3.cursor-pointer.hover-bg(@click="onToggleType(option.value)")
        yz-checkbox(:value="selectedTypes.includes(option.value)")
        .ml-4 {{ option.label }}
      yz-divider(color="yz-neutral-300")
</template>

<script>
export default {
  props: {
    filter: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      selectedTypes: [],
      isActive: false,
      displayValue: ''
    }
  },
  computed: {
    visitTypeOptions() {
      return [
        { label: 'Walk-in', value: 1 },
        { label: 'Appointment', value: 2 },
        { label: 'OTC', value: 3 }
      ]
    }
  },
  methods: {
    onToggleType(value) {
      const index = this.selectedTypes.indexOf(value)
      if (index > -1) {
        this.selectedTypes.splice(index, 1)
      } else {
        this.selectedTypes.push(value)
      }
    },
    onClear() {
      this.selectedTypes = []
      this.isActive = false
      this.displayValue = ''
      this.$emit('update:filter', {})
    },
    onApply() {
      this.isActive = true
      const count = this.selectedTypes.length

      if (count <= 2) {
        const labels = this.selectedTypes.map(val => this.visitTypeOptions.find(o => o.value === val)?.label)
        this.displayValue = labels.join(', ')
      } else {
        this.displayValue = `${count} ${this.$t('selected')}`
      }

      this.$emit('update:filter', {
        key: 'visit_codes',
        value: this.selectedTypes.join(',')
      })
    },
    reset() {
      this.onClear()
    },
    restoreFromParams(params) {
      // Restore filter state from URL params
      if (params.visit_types) {
        // Parse comma-separated values
        this.selectedTypes = params.visit_types.split(',')
        this.onApply()
      }
    }
  }
}
</script>

<style scoped>
.hover-bg:hover {
  background-color: #f5f5f5;
}
</style>
